/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseUser } from './BaseUser';
import { Group } from './Group';
const GroupUserParser = /* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['type', /* #__PURE__ */ parsers.exactly('group-user')],
    ['group', Group],
    ['isTestStudent', /* #__PURE__ */ parsers.exactly(false), 'is_test_student'],
]), BaseUser);
export class GroupUser extends BaseUser {
    static decode(input) {
        return GroupUserParser.decode(input).map(res => new GroupUser(res));
    }
    static unsafeDecode(input) {
        return GroupUser.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return GroupUserParser.encode(data);
    }
    static schema() {
        return GroupUserParser.schema();
    }
}
